
import "babel-polyfill";
import React from "react";
import {render} from "react-dom";
import Wrapper from "./containers/Wrapper"; 

render(<Wrapper/>, document.getElementById('react'));